import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import HeadingLines from '../assets/images/heading-lines.svg' 
//import CountUp from "react-countup";
function AboutUsNumbers({data}) {
  return (
    <>     
    {(data) && (
    <section className="about-us-numbers">
      <Container>
        <Row>
          <Col md="12">
              <div className="common-header">
                <img src={HeadingLines} alt="" />
                <h2>{data.title}</h2> 
                <p className='m-0' dangerouslySetInnerHTML={{ __html: data.description }}></p>
              </div>
              <div className="stats-container">
              {data.cards.map((row, index) => (
                <div className="stat-item" key={"c"+index}>
                  <h3>
                    {/* $<CountUp start={0} end={340} duration={2.5} /> */}
                    {row.title}
                  </h3>
                  <span>
                    {row.subtitle}
                  </span>
                  <p dangerouslySetInnerHTML={{ __html: row.description }}></p>
                </div>
              ))}
                
              </div>
          </Col>         
        </Row>        
      </Container>
    </section>
    )}
    </>

  )
}
export default AboutUsNumbers